/* eslint-disable no-undef */
/** @jsx jsx */
// eslint-disable-next-line
import React from 'react'
import { css, jsx } from '@emotion/core'
import { toast } from 'react-toastify'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import userService from '../../services/user'
import DownloadBoxes from './components/DownloadBoxes'
import playBaseLogo from '../../assets/play-base-logo.svg'
import nexusLogo from '../../assets/nexus-logo.svg'
import { Products } from '../../constants'

const styles = {}

styles.container = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`

styles.downloads = css`
  display: flex;
  justify-content: center;
  gap: 40px;

  @media (max-width: 1050px) {
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`

styles.loading = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 25px;
`

styles.textContainer = css`
  margin: 0 50px;

  @media (max-width: 1050px) {
    margin: 0;
  }
`

styles.bodyTitle = css`
  text-align: center;
  font-size: 36px;
  font-weight: bolder;
  line-height: 70px;
  z-index: 10;
  margin-bottom: 40px;
`

styles.bodyText = css`
  text-align: center;
  margin-bottom: 12px;
  font-size: 20px;
`

styles.secondBodyText = css`
  text-align: center;
  margin-bottom: 12px;
  font-size: 20px;
  margin-bottom: 70px;
`

function Downloads(props) {
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(false)
  const [play2Mac, setPlay2Mac] = React.useState({})
  const [play2Windows, setPlay2Windows] = React.useState({})
  const [play3Mac, setPlay3Mac] = React.useState({})
  const [play3Windows, setPlay3Windows] = React.useState({})

  React.useEffect(() => {
    getLinks(setPlay2Mac, setPlay2Windows, setPlay3Mac, setPlay3Windows, setLoading, setError)
    trackPageView(props.fromTrial)
  }, [])

  const showPlay2 = props.app !== Products.NEXUS
  const showPlay3 = props.app !== Products.PLAY_BASE

  return loading ? (
    <div css={styles.loading}>
      <CircularProgress size={45} thickness={3} />
    </div>
  ) : (
    error || (
      <div css={styles.container}>
        <div css={styles.textContainer}>
          <BodyTitle bodyTitle={props.bodyTitle} />
          <div css={styles.bodyText}>{props.bodyText}</div>
          <div css={styles.secondBodyText}>{props.secondBodyText}</div>
        </div>

        <div css={styles.downloads}>
          {showPlay2 && (
            <DownloadBoxes
              logo={playBaseLogo}
              mac={play2Mac}
              windows={play2Windows}
              styleButtons={{
                background: 'var(--play-base-green)',
                color: 'black'
              }}
              baseKeyTranslations="download.play2"
              ctaLabelPrefix="playbase"
              borderColor={'var(--play-base-green)'}
              background={'var(--play-base-green-black-gradient)'}
            />
          )}
          {showPlay3 && (
            <DownloadBoxes
              logo={nexusLogo}
              mac={play3Mac}
              windows={play3Windows}
              styleButtons={{
                background: 'var(--nexus-blue)',
                color: 'white'
              }}
              baseKeyTranslations="download.play3"
              ctaLabelPrefix="nexus"
              borderColor={'var(--nexus-blue)'}
              background={'var(--nexus-blue-black-gradient)'}
            />
          )}
        </div>
      </div>
    )
  )
}

function BodyTitle(props) {
  return <div css={styles.bodyTitle}>{props.bodyTitle}</div>
}

BodyTitle.propTypes = {
  bodyTitle: PropTypes.string.isRequired
}

async function getLinks(
  setPlay2Mac,
  setPlay2Windows,
  setPlay3Mac,
  setPlay3Windows,
  setLoading,
  setError
) {
  try {
    const { data } = await userService.getMetricaPlayLinks()
    setPlay2Mac(data.play2.mac)
    setPlay2Windows(data.play2.windows)
    setPlay3Mac(data.play3.mac)
    setPlay3Windows(data.play3.windows)
  } catch (e) {
    console.log('Error downloading Play links', e)
    toast.error(window.I18n.t('error.tryAgainMsg'))
    setError(true)
  } finally {
    setLoading(false)
  }
}

function trackPageView(fromTrial) {
  const isProduction = process.env.REACT_APP_ENV === 'production'
  const sendGtagEvent = isProduction && fromTrial
  if (sendGtagEvent) {
    const key = process.env.REACT_APP_GTAG_KEY
    gtag('event', 'conversion', { send_to: `AW-${key}/nNn8CJmktKkBEKnDhNUC` })
  }
  if (isProduction) {
    fbq('track', 'PageView')
    twq('track', 'PageView')
  }
}

Downloads.defaultProps = {
  fromTrial: false,
  secondBodyText: '',
  app: undefined
}

Downloads.propTypes = {
  bodyText: PropTypes.string.isRequired,
  bodyTitle: PropTypes.string.isRequired,
  fromTrial: PropTypes.bool,
  secondBodyText: PropTypes.string,
  app: PropTypes.string
}

export default Downloads
